import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { contentfulModels } from '@glowforge/ui-common';
import Dialog from 'app/common/components/dialog';
import SubmitActions from 'app/common/components/forms/submit-actions';
import { machinePropType } from 'app/selectors/machines';
import features from 'app/common/containers/features';
import MachineCheckboxGroup from './machine-checkbox-group';
import MachineAccessField from 'app/containers/settings/machine-access-field';
import SubscriptionsToggle from './subscriptions-toggle';

import './change-access-dialog.less';

const { pageStringsPropType } = contentfulModels;

let UserAccessForm = (props) => { // eslint-disable-line
  const name = _.get(props.user, 'displayName') ? _.get(props.user, 'displayName')
    : _.get(props.user, 'name');

  let machines;

  let fieldComponent = MachineCheckboxGroup;
  if (props.features.USER_ROLE_MANAGEMENT) fieldComponent = MachineAccessField;

  // TODO: when this code migrates elsewhere, this kind of cleanup should be
  // done in the layer that gets machine lists -- that is it should mark there
  // whether the current user can modify it (can they even see the list of users
  // on a machine without manage access?!)
  //
  // Users can only change access to machines they manage, so ignore the rest.
  const managedMachines = props.machines.filter(machine =>
    _.includes(machine.abilities, 'manage_access_to'));
  // TODO: [APP-3613] always execute this block after cleaning up USER_ROLE_MANAGEMENT flag.
  // For whatever reason, this still executes even as the cancel happens and
  // props.user becomes null so make sure not to try to access it in that case.
  if (props.user && (managedMachines.length > 0 || props.features.USER_ROLE_MANAGEMENT)) {
    machines = (
      <Field
        name='machines'
        component={fieldComponent}
        email={props.user.email}
        options={managedMachines}
        pageStrings={props.pageStrings} />
    );
  }

  const email = _.get(props.user, 'email');

  return (
    <form className='UserAccessForm' onSubmit={props.handleSubmit}>
      <div className='EmailMemberHeader'>
        <h4 className='h4'>
          {name}
          <span className='email'>({email})</span>
        </h4>
        <SubscriptionsToggle
          email={email}
          isSubscriber={props.isSubscriber}
          isSecondaryMember={props.isSecondaryMember}
          addedUsers={props.addedUsers}
          totalUsers={props.totalUsers}
          pageStrings={props.pageStrings} />
      </div>
      {machines}
      <SubmitActions
        {...props}
        submitText='Save'
        successMessage='Access Changed!'
        inProgressMessage='Saving...'
        onCancel={props.onCancel} />
    </form>
  );
};

UserAccessForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  machines: PropTypes.arrayOf(PropTypes.shape(machinePropType)),
  user: PropTypes.shape({ email: PropTypes.string }).isRequired,
  features: PropTypes.object, // eslint-disable-line
  pageStrings: pageStringsPropType.isRequired,
  isSubscriber: PropTypes.bool,
  isSecondaryMember: PropTypes.bool,
  addedUsers: PropTypes.array, // eslint-disable-line
  totalUsers: PropTypes.number,
};

UserAccessForm.defaultProps = {
  machines: [],
  machineListError: null,
  isSubscriber: false,
  isSecondaryMember: false,
  addedUsers: [],
  totalUsers: 0,
  onCancel: () => {},
};

UserAccessForm = reduxForm({
  form: 'userAccessForm',
})(UserAccessForm);


const ChangeAccessDialog = (props) => {
  if (!props.isOpen) {
    return null;
  }

  const email = _.get(props.user, 'email');
  const isSecondaryMember = !!_.find(
    props.addedUsers,
    item => item.attributes.secondary_user_email === email,
  );

  const initialValues = {
    email: _.get(props.user, 'email'),
    machines: _.map(_.get(props.user, 'machines'), m => ({
      serial: m.serial,
      machineName: m.machineName,
      roles: m.roles,
    })),
    subscriber: isSecondaryMember,
  };

  // subscriptions related props
  const { isSubscriptionsEnabled, subscription, addedUsers } = props;
  const subscriptionData = isSubscriptionsEnabled ?
    { subscription, addedUsers, email: initialValues.email } : {};

  const onSubmit = (values) => {
    props.onAccessChangeSubmit(values, initialValues, subscriptionData);
  };

  const onSubmitSuccess = () => {
    // Icky.. but right now the success notification is in the dialog
    // so i'm holding it open for a couple seconds.
    // We need to get global notifications up and running
    setTimeout(props.closeDialog, 2000);
  };

  return (
    <Dialog
      className='ChangeAccessDialog'
      title='Glowforge Printer Access for:'
      isOpen={props.isOpen}>
      <UserAccessForm
        {...props}
        isSecondaryMember={isSecondaryMember}
        initialValues={initialValues}
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
        onCancel={props.closeDialog} />
    </Dialog>
  );
};

ChangeAccessDialog.propTypes = {
  isOpen: PropTypes.bool,
  onAccessChangeSubmit: PropTypes.func.isRequired, // eslint-disable-line
  closeDialog: PropTypes.func.isRequired,
  machines: PropTypes.arrayOf(PropTypes.shape(machinePropType)),
  user: PropTypes.object, // eslint-disable-line
  features: PropTypes.object, // eslint-disable-line
  isSubscriptionsEnabled: PropTypes.bool,
  isSubscriber: PropTypes.bool,
  subscription: PropTypes.object, // eslint-disable-line
  addedUsers: PropTypes.array, // eslint-disable-line
  totalUsers: PropTypes.number,
  onSetMembership: PropTypes.func,
};

ChangeAccessDialog.defaultProps = {
  isOpen: false,
  machines: [],
  user: null,
  isSubscriptionsEnabled: false,
  isSubscriber: false,
  subscription: {},
  addedUsers: [],
  totalUsers: 0,
  onSetMembership: () => {},
};

export default features(ChangeAccessDialog);



// WEBPACK FOOTER //
// ./app/components/settings/change-access-dialog.jsx